import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Plus, Minus, Rocket } from "lucide-react";

const STEPS = [
  {
    n: "01",
    title: "Diagnóstico e Auditoria",
    summary: "Mergulhamos no seu negócio para encontrar gargalos, oportunidades e pontos de perda de dinheiro.",
  },
  {
    n: "02",
    title: "Posicionamento",
    summary: "Definimos a mensagem e o posicionamento que diferenciam a sua marca no mercado.",
  },
  {
    n: "03",
    title: "Atração",
    summary: "Estratégias de tráfego, conteúdo e redes para atrair os clientes certos com previsibilidade.",
  },
  {
    n: "04",
    title: "Conversão",
    summary: "Processo de vendas e CRM estruturados para transformar leads em clientes de forma consistente.",
  },
  {
    n: "05",
    title: "Gestão, Retenção e Escala",
    summary: "Indicadores, controle financeiro e rotina para reter clientes e escalar com segurança.",
  },
];

export default function Methodology() {
  const [open, setOpen] = useState(0);

  return (
    <div data-testid="methodology" className="w-full">
      <div className="flex items-center gap-3 mb-6">
        <span className="inline-block rounded-full border border-efory-blue/40 px-4 py-1.5 text-xs font-semibold uppercase tracking-[0.2em] text-efory-blue">
          Metodologia Validada
        </span>
      </div>

      <div className="space-y-3">
        {STEPS.map((s, i) => {
          const isOpen = open === i;
          return (
            <motion.div
              key={s.n}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.5, delay: i * 0.08 }}
              whileHover={{ x: 10 }}
              data-testid={`methodology-step-${i}`}
              onClick={() => setOpen(isOpen ? -1 : i)}
              className={`cursor-pointer rounded-2xl border px-5 sm:px-6 py-4 transition-colors duration-300 ${
                isOpen
                  ? "bg-efory-blue/10 border-efory-blue/50"
                  : "bg-white/[0.03] border-white/10 hover:border-efory-blue/40 hover:bg-white/[0.05]"
              }`}
            >
              <div className="flex items-center justify-between gap-4">
                <div className="flex items-center gap-4">
                  <span className={`font-heading text-sm font-bold ${isOpen ? "text-efory-blue" : "text-white/40"}`}>
                    {s.n}
                  </span>
                  <h4 className="font-heading text-base sm:text-lg font-bold text-white leading-tight">
                    {s.title}
                  </h4>
                </div>
                <span className={`shrink-0 h-7 w-7 rounded-full flex items-center justify-center ${isOpen ? "bg-efory-blue text-white" : "bg-white/5 text-white/60"}`}>
                  {isOpen ? <Minus className="h-4 w-4" /> : <Plus className="h-4 w-4" />}
                </span>
              </div>
              <AnimatePresence initial={false}>
                {isOpen && (
                  <motion.p
                    initial={{ height: 0, opacity: 0 }}
                    animate={{ height: "auto", opacity: 1 }}
                    exit={{ height: 0, opacity: 0 }}
                    transition={{ duration: 0.3 }}
                    className="text-sm text-white/65 leading-relaxed overflow-hidden pl-8"
                  >
                    <span className="block pt-3">{s.summary}</span>
                  </motion.p>
                )}
              </AnimatePresence>
            </motion.div>
          );
        })}

        {/* Final highlight card */}
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: STEPS.length * 0.08 }}
          data-testid="methodology-final"
          className="rounded-2xl bg-efory-blue px-6 py-5 flex items-center gap-4 shadow-xl shadow-efory-blue/25"
        >
          <span className="h-11 w-11 shrink-0 rounded-xl bg-white/20 flex items-center justify-center">
            <Rocket className="h-6 w-6 text-white" />
          </span>
          <p className="font-heading text-base sm:text-lg font-extrabold text-white uppercase leading-tight">
            Passo a passo para construir uma empresa imparável
          </p>
        </motion.div>
      </div>
    </div>
  );
}
